import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  text-decoration: inherit;\n  vertical-align: bottom;\n  ", "\n  ", "\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:active {\n    color: ", ";\n  }\n\n  ", " {\n    color: inherit;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 4px;\n  vertical-align: middle;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { space, typography } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { ellipsis } from 'polished';
import { Icon } from '../icon/Icon';
import { Group } from '../group/Group';
var StyledIcon = styled(Icon)(_templateObject());
var StyledLink = styled.a(_templateObject2(), ellipsis(), themeGet('link.color'), space, typography, themeGet('link.hover.color'), themeGet('link.active.color'), StyledIcon);

var Link = function Link(_ref) {
  var icon = _ref.icon,
      iconSize = _ref.iconSize,
      href = _ref.href,
      children = _ref.children,
      target = _ref.target,
      rest = _objectWithoutProperties(_ref, ["icon", "iconSize", "href", "children", "target"]);

  var _useContext = useContext(ThemeContext),
      defaultLinkStyle = _useContext.link;

  return (
    /*#__PURE__*/
    React.createElement(StyledLink, _extends({
      rel: "noopener",
      target: target,
      href: href
    }, defaultLinkStyle, rest), icon &&
    /*#__PURE__*/
    React.createElement(StyledIcon, {
      fontSize: iconSize,
      name: icon
    }), children)
  );
};

Link.defaultProps = {
  target: '_blank',
  iconSize: 20
};
var LinkGroup = styled(Group).attrs({
  itemStyle: {
    mr: 4
  }
})(_templateObject3());
Link.Group = LinkGroup;
export { Link };